export const PAGE_ACTIONS = {
  FETCH_CONTENT: 'PAGE/FETCH_CONTENT',
  FETCH_CONTENT_SUCCESS: 'PAGE/FETCH_CONTENT_SUCCESS',
  FETCH_CONTENT_ERROR: 'PAGE/FETCH_CONTENT_ERROR',

  PRE_FETCH_CONTENT: 'PAGE/PRE_FETCH_CONTENT',
  PRE_FETCH_CONTENT_SUCCESS: 'PAGE/PRE_FETCH_CONTENT_SUCCESS',
  PRE_FETCH_CONTENT_ERROR: 'PAGE/PRE_FETCH_CONTENT_ERROR',
};
